export const translations = {
  // ── StartPage
  "start.tagline":        { ko: "나만의 액상을 찾아볼까?",           en: "Find Your\nPerfect Liquid?" },
  "start.noImages":       { ko: "스타트페이지 이미지가 아직 없어.", en: "No start images yet." },

  // ── UserInfoPage
  "userinfo.title":       { ko: "고객님의 간단한 정보를 선택해주세요!", en: "Tell us a bit about yourself!" },
  "userinfo.gender":      { ko: "성별",   en: "Gender" },
  "userinfo.age":         { ko: "연령대", en: "Age Group" },
  "userinfo.male":        { ko: "남성",      en: "Male" },
  "userinfo.female":      { ko: "여성",      en: "Female" },
  "userinfo.20s":         { ko: "20대",      en: "20s" },
  "userinfo.30s":         { ko: "30대",      en: "30s" },
  "userinfo.40s":         { ko: "40대",      en: "40s" },
  "userinfo.50plus":      { ko: "50대 이상", en: "50s+" },

  // ── CategoryPage
  "category.title":       { ko: "액상의 \" 맛 \" 을 선택해주세요!", en: "Choose Your Flavor!" },
  "category.dessert":     { ko: "디저트", en: "Dessert" },
  "category.cigar":       { ko: "연초",   en: "Tobacco" },
  "category.menthol":     { ko: "멘솔",   en: "Menthol" },
  "category.fruit":       { ko: "과일",   en: "Fruit" },
  "category.drink":       { ko: "음료",   en: "Drink" },

  // ── MentholPage
  "menthol.title":        { ko: "\"멘솔강도(쿨링)\"를 선택해주세요!", en: "Choose Your Cooling Level!" },
  "menthol.0":            { ko: "없음",       en: "None" },
  "menthol.1":            { ko: "미세 시원함", en: "Barely Cool" },
  "menthol.2":            { ko: "약간 시원함", en: "Slightly Cool" },
  "menthol.3":            { ko: "제법 시원함", en: "Moderately Cool" },
  "menthol.4":            { ko: "꽤 시원함",   en: "Quite Cool" },
  "menthol.5":            { ko: "강력 시원함", en: "Icy Cool" },
  "menthol.dontKnow":     { ko: "잘 모르겠어요", en: "Not Sure" },

  // ── SweetnessPage
  "sweetness.title":      { ko: "\"당도\"를 선택해주세요!",          en: "Choose Your Sweetness Level!" },
  "sweetness.0":          { ko: "없음",        en: "None" },
  "sweetness.1":          { ko: "미세 달콤함", en: "Barely Sweet" },
  "sweetness.2":          { ko: "약간 달콤함", en: "Slightly Sweet" },
  "sweetness.3":          { ko: "제법 달콤함", en: "Moderately Sweet" },
  "sweetness.4":          { ko: "꽤 달콤함",   en: "Quite Sweet" },
  "sweetness.5":          { ko: "진한 달콤함", en: "Very Sweet" },
  "sweetness.dontKnow":   { ko: "잘 모르겠어요", en: "Not Sure" },

  // ── StrongnessPage
  "strongness.title":     { ko: "\"타격감강도(목넘김)\"를 선택해주세요!", en: "Choose Your Hit Strength!" },
  "strongness.1":         { ko: "약함",   en: "Mild" },
  "strongness.2":         { ko: "적당함", en: "Medium" },
  "strongness.3":         { ko: "강함",   en: "Strong" },
  "strongness.dontKnow":  { ko: "잘 모르겠어요", en: "Not Sure" },

  // ── StylePage (title split into two lines)
  "style.titleLine1":     { ko: "액상의 \"스타일\"을 선택해주세요!", en: "Choose Your Vibe!" },
  "style.titleLine2":     { ko: "(최대3개)",                         en: "(up to 3)" },
  "style.달콤":           { ko: "달콤",  en: "Sweet" },
  "style.크리미":         { ko: "크리미", en: "Creamy" },
  "style.산뜻":           { ko: "산뜻",  en: "Fresh" },
  "style.청량":           { ko: "청량",  en: "Crisp" },
  "style.구수":           { ko: "구수",  en: "Toasty" },
  "style.묵직":           { ko: "묵직",  en: "Rich" },
  "style.깔끔":           { ko: "깔끔",  en: "Clean" },
  "style.은은":           { ko: "은은",  en: "Subtle" },
  "style.새콤":           { ko: "새콤",  en: "Tangy" },

  // ── Recommend (RECOMMEND_COPY equivalents)
  "reco.pickConfirmSuffix": { ko: "개의 액상을 확정하시겠습니까?", en: " liquid(s) — confirm pick?" },
  "reco.cancel":            { ko: "취소",    en: "Cancel" },
  "reco.confirm":           { ko: "확인",    en: "Confirm" },
  "reco.matchPercent":      { ko: "적합도:", en: "Match:" },
  "reco.liquidName":        { ko: "액상명:", en: "Name:" },
  "reco.oneLineReview":     { ko: "한줄평:", en: "Review:" },
  "reco.menthol":           { ko: "멘솔 :",  en: "Cool:" },
  "reco.sweetness":         { ko: "당도 :",  en: "Sweet:" },
  "reco.strongness":        { ko: "타격감 :", en: "Hit:" },
  "reco.previous":          { ko: "이전",    en: "Back" },
  "reco.moreRecommend":     { ko: "더 추천받기", en: "More Picks" },
  "reco.pickConfirm":       { ko: "선택 확정",   en: "Confirm Pick" },
  "reco.longPressHint":     { ko: "길게 눌러 상세설명 확인", en: "Hold to see details" },
  "reco.more":              { ko: "더 보기",                 en: "More" },
  "reco.autoConfirm":       { ko: "자동확인",                en: "Auto Flip" },
  "reco.noRecommendation":  { ko: "[조건에 맞는 추천 액상]이 없습니다!", en: "No matching liquids found!" },
  "reco.confirmDoneAlt":    { ko: "확정 완료",             en: "Confirmed!" },
  "reco.confirmDoneText":   { ko: "확정이 완료되었습니다", en: "Pick confirmed!" },

  // ── FruitsPage
  "fruits.title":    { ko: "\" 과일 \" 을 선택해주세요! (복수선택가능)", en: "Choose Your Fruit! (pick multiple)" },
  "fruits.lemon":    { ko: "레몬&라임",   en: "Lemon&Lime" },
  "fruits.peach":    { ko: "복숭아&자두", en: "Peach&Plum" },
  "fruits.melon":    { ko: "멜론&수박",   en: "Melon&Watermelon" },
  "fruits.apple":    { ko: "사과",        en: "Apple" },
  "fruits.grape":    { ko: "포도",        en: "Grape" },
  "fruits.aloe":     { ko: "알로에",      en: "Aloe" },
  "fruits.berry":    { ko: "베리",        en: "Berry" },
  "fruits.tropical": { ko: "트로피칼",    en: "Tropical" },
  "fruits.other":    { ko: "기타과일",    en: "Other Fruit" },
  "fruits.all":      { ko: "모든과일",    en: "All Fruits" },

  // ── CartDrawer
  "cart.cartLabel": { ko: "카트",     en: "Cart" },
  "cart.collapse":  { ko: "접기",     en: "Close" },
  "cart.addReco":   { ko: "추가 추천", en: "Add Rec" },
  "cart.confirm":   { ko: "확정",     en: "Confirm" },
  "cart.submitFailed": { ko: "픽 확정에 실패했어요. 다시 시도해 주세요.", en: "Couldn't confirm your picks. Please try again." },

  // ── Recommend detail / BrandView
  "reco.brandMore":     { ko: "이 브랜드 더 보기 →", en: "More from this brand →" },
  "brand.back":         { ko: "← 뒤로",            en: "← Back" },
  "brand.recommended":  { ko: "추천됨",            en: "Suggested" },
  "brand.otherLiquids": { ko: "의 다른 액상",       en: "'s other liquids" },

  // ── Error / Fallback
  "error.noAvailable":   { ko: "이 조합으로는 추천 가능한 액상이 없습니다.", en: "No liquids available for this combination." },
  "error.retryCategory": { ko: "카테고리부터 다시 선택",                    en: "Try a different category" },
};
